// Date and time formats
const formats = {
    date: 'ccc, MMM d',
    dateLong: {
        upper: 'd MMM',
        bottom: 'EEEE',
    },
    time: 'h:mm a',
};

export default formats;
